import { extends as _extends, objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useSafeThemeUI } from '../../../theme-provider/use-theme-ui.esm.js';
import { get } from '../../../utils/object.esm.js';
import { TextPrivate } from '../text/text.esm.js';

var _excluded = ["as", "__css", "__themeKey", "className", "variant", "children", "ellipsis", "lhCrop"];
function isHeadingType(v) {
  return v && ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(v.toLowerCase());
}
var HeadingPrivate = /*#__PURE__*/React.forwardRef(function HeadingPrivate(props, ref) {
  var _props$as = props.as,
    asProps = _props$as === void 0 ? 'h1' : _props$as;
    props.__css;
    var _props$__themeKey = props.__themeKey,
    __themeKey = _props$__themeKey === void 0 ? 'headings' : _props$__themeKey,
    _props$className = props.className,
    className = _props$className === void 0 ? 'csg-tui-heading' : _props$className,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? '__default' : _props$variant,
    children = props.children,
    ellipsis = props.ellipsis,
    lhCropProps = props.lhCrop,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useSafeThemeUI(props);
  var lhCrop = typeof lhCropProps === 'boolean' && lhCropProps ? __themeKey !== 'headings' && variant ?
  // if themeKey is not default find possible lhCrop in the theme so we know how to handle the condition wrap
  get(theme, "".concat(__themeKey, ".").concat(variant, ".lhCrop"), isHeadingType(asProps) ? "heading.".concat(asProps) : 'body') : isHeadingType(asProps) ? "heading.".concat(asProps) : 'body' : lhCropProps;
  return /*#__PURE__*/React.createElement(TextPrivate, _extends({
    __themeKey: __themeKey,
    ref: ref,
    as: asProps,
    variant: variant ? variant : asProps,
    className: className,
    lhCrop: lhCrop ? lhCrop : undefined,
    ellipsis: ellipsis,
    resetCss: {
      marginBlockStart: 'unset',
      marginBlockEnd: 'unset'
    }
  }, rest), children);
});
var Heading = /*#__PURE__*/React.forwardRef(function Heading(props, ref) {
  return /*#__PURE__*/React.createElement(HeadingPrivate, _extends({
    ref: ref
  }, props));
});

export default Heading;
export { HeadingPrivate };
//# sourceMappingURL=heading.esm.js.map
